import React from "react";
import { Navigate } from "react-router-dom";

import { useTenant } from "../../contexts/TenantContext";
import AgentWorkspaceProductionShell from "./AgentWorkspaceProductionShell";
import AgentWorkspaceShell from "./AgentWorkspaceShell";
import {
  AGENT_WORKSPACE_FALLBACK_ROUTE,
  isAgentWorkspaceEnabled,
} from "./agentWorkspaceGate";

export default function AgentWorkspaceRoute() {
  const { loading: tenantLoading, selectedTenantId } = useTenant();

  // Reuses the same canonical account-context loading signal
  // PermissionGuard.jsx's RequireModule already waits on -- never grant
  // access, but never redirect either, while identity is unresolved.
  if (tenantLoading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <div className="text-center space-y-4">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
          <p className="text-sm text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAgentWorkspaceEnabled({ accountId: selectedTenantId })) {
    return <Navigate to={AGENT_WORKSPACE_FALLBACK_ROUTE} replace />;
  }

  // Reaching this point means the gate already resolved to true, which
  // (per agentWorkspaceGate.js) only ever happens for exactly two
  // environments: development (fixture Boundary-A shell, unconditional)
  // or production (allowlisted account, real Campaign Login only -- no
  // fixture runtime). Every other environment already fails closed above.
  if (process.env.NODE_ENV === "production") {
    return <AgentWorkspaceProductionShell />;
  }

  return <AgentWorkspaceShell />;
}
